import dynamic from "next/dynamic";
import ProductsByUseCasesHomepageFirstFoldConfig from "./products-by-use-cases-homepage-first-fold-config";
import ProductsByUseCasesHomepageFirstFoldAdvancedConfig from "./products-by-use-cases-homepage-first-fold-advanced-config";
const ProductsByUseCasesHomepageFirstFoldComponent = dynamic(()=>import("./products-by-use-cases-homepage-first-fold-component"));
export default {
    ProductsByUseCasesHomepageFirstFoldComponent,
    ProductsByUseCasesHomepageFirstFoldConfig,
    ProductsByUseCasesHomepageFirstFoldAdvancedConfig
};
